import { instance } from "../apiclient";
import { AppConfig } from "./../../../AppConfig";

export class StripePay {
  baseUrl = "stripepayment/";
  constructor(request) {
    this.params = request;
  }
  createOrder(trackingOrder, errorhandler) {
    return instance.post(
      this.baseUrl + trackingOrder.TrackingOrder.UDID, trackingOrder)
      .catch((e) => {
        if (errorhandler) errorhandler(e.message);
      });
  }

  createPayment(order, errorhandler) {
    // Get the amount to request from the form and set up
    // the totals and line items for collection and delivery.
    var deliveryTotal =
      Math.round((order.TotalExcludingTax + order.TotalTax) * 100) / 100;

    // var countryCode = order.countryCode;
    // var currencyCode = order.currencyCode;

    return instance
      .post(`${this.baseUrl}${order.StoreID}/createpayment/${order.UDID}`, {
        Amount: deliveryTotal,
        ContactNumber: order.ContactCustomer_Contact_Number,
        Email: order.ContactCustomer_Email_Address,
        FirstName: order.ContactCustomer_FirstName,
        LastName: order.ContactCustomer_LastName,
      })
      .catch((e) => {
        if (errorhandler) errorhandler(e.message);
      });
  }

  async payByCard(trackingOrder) {
    let result = { success: false, message: "" };
    // const isPayLater = trackingOrder.TrackingOrder.PaymentTransactions[0].PaymentMethodType === null;
    const isPayByPoints =
      trackingOrder.TrackingOrder.PaymentTransactions.length === 1
        && trackingOrder.TrackingOrder.PaymentTransactions[0].PaymentMethodType == 10;
    try {
      let order = trackingOrder.TrackingOrder;
      var deliveryTotal =
        Math.round((order.TotalExcludingTax + order.TotalTax) * 100) / 100;
      let body = {
        Amount: deliveryTotal,
        ContactNumber: order.ContactCustomer_Contact_Number,
        Email: order.ContactCustomer_Email_Address,
        FirstName: order.ContactCustomer_FirstName,
        LastName: order.ContactCustomer_LastName,
        Card: trackingOrder.Card,
        // is3dsCard: !isPayLater && !isPayByPoints,
        is3dsCard: false
      };

      let payRes = await instance.post(
        `${this.baseUrl}${order.StoreID}/createpayment/${order.UDID}`,
        body
      );

      if (!payRes.data.Success) {
        throw new Error(payRes.data.Status.Message);
      }

      if(isPayByPoints) {
        result.success = true;
      } else {
        /* global Stripe */
        let stripe = Stripe(AppConfig.stripeToken);
        let clientSecret = payRes.data.ClientSecret;
        let stripeResult = await stripe.confirmCardPayment(clientSecret);
        if (stripeResult.error) {
          throw new Error(stripeResult.error.message);
        } else {
          if (stripeResult.paymentIntent.status === "succeeded") {
            result.success = true;
          }
        }
      }

      return result;
    } catch (error) {
      result.message = error;
      result.success = false;
      return result;
    }
  }

}
